module.exports = __webpack_public_path__ + "static/media/updateAssignments.1c646fa6.svg";